const { cELM, unique } = require("../../utils");
const Chat = require("../../chat");

class SingleSelectInsurance {
    constructor(data) {
        this._data = data;
        this.options = unique(this._data.values.split("|"));
        this.element = cELM("div", "option-block");
    }

    getELM() {
        return this.element;
    }

    getHTML() {
        const _self = this;
        this.options.forEach(op => {
            op = op.trim();
            const className = (op || '').indexOf('<div class="rate-') > -1 ? ' rate-opt' : '';
            const _el = cELM("div", 'option' + className);
          
            if (typeof op === 'string') {
                const DONTKNOW = getLngTxt('insurance.DONTKNOW') || "i'm not sure"
                const OTHER = getLngTxt('insurance.OTHER') || "show more insurances"
                if (op.toLowerCase() === DONTKNOW) {
                    _el.classList.add('insurance-unsure');
                } else if (op.toLowerCase() === OTHER) {
                    _el.classList.add('insurance-more');
                }
            }

            _el.onclick = function(evt) {
                _el.classList.toggle("option-active");

                let data = (window.__FN_DATA_WRAPPER) ? window.__FN_DATA_WRAPPER(op) : op;

                data = (typeof data == 'string')
                    ? { text: data, id: _self._data.id }
                    : { ...data, id: _self._data.id };

                Chat.default.send(data, null, _self.element);
            };

            _el.innerHTML = '<div class="option-text">' + op + "</div>";

            this.element.addELM(_el);
        });

        return this.element;
    }

    reset() {
        let sibling = this.element.firstChild;
        while (sibling) {
            sibling.classList.remove("option-active");
            sibling = sibling.nextSibling;
        }
        this.selectedOptions = [];
    }

    focus() {}
}

module.exports = SingleSelectInsurance;
